'use client'

import { Checkbox } from '@components/primitives/Checkbox'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import absoluteUrl from '@lib/routes/helpers/absoluteUrl'
import urlWithQueryParams from '@lib/routes/helpers/urlWithQueryParams'
import createFacetFiltersFromSlug from '@modules/trials/search/facetFilters/createFacetFiltersFromSlug'
import updateFacetFilterFromSlug from '@modules/trials/search/facetFilters/updateFacetFilterFromSlug'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useState } from 'react'

export function PaidTrialFilterRefinementList({
  defaultOpen = false,
  inputClassName,
}: {
  defaultOpen?: boolean
  inputClassName?: string
}) {
  const pathname = usePathname()
  const router = useRouter()
  const searchParams = new URLSearchParams(useSearchParams() ?? '')

  if (searchParams.has('page')) {
    searchParams.delete('page')
  }

  const [isOpen, setIsOpen] = useState(defaultOpen)

  const { paid } = createFacetFiltersFromSlug(pathname ?? '')
  const [isPaidTrial, setIsPaidTrial] = useState(paid === 'true')

  const handleToggle = () => {
    setIsPaidTrial(!isPaidTrial)

    const url = updateFacetFilterFromSlug({
      facet: 'paid',
      slug: pathname,
      value: !isPaidTrial ? 'true' : '',
    })

    if (url) {
      router.push(
        absoluteUrl(
          urlWithQueryParams(url.toString(), {
            ...Object.fromEntries(searchParams),
          }),
        ),
      )
    }
  }

  return (
    <div
      className={classMerge(
        'w-full rounded-lg  border-grey200 bg-white',
        inputClassName,
      )}
    >
      <div
        className='flex w-full cursor-pointer items-center justify-between self-center'
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className='flex items-center justify-center gap-1'>
          <Text
            className='text-neutral900 antialiased'
            element='p'
            styleName='p-small-strong'
          >
            Paid Participation
          </Text>
        </div>
      </div>
      <label className='flex cursor-pointer items-center pb-2'>
        <Checkbox
          checked={isPaidTrial}
          className='flex-shrink-0'
          onChange={handleToggle}
        />
        <span className='ml-2 text-base leading-7 text-neutral900'>
          Only show trials that pay for healthy volunteers
        </span>
      </label>
    </div>
  )
}
